module.exports = __webpack_public_path__ + "img/forgot_password.da55ce65.svg";